module.exports = __webpack_public_path__ + "img/CreisLogo_newS2.e4fb9d3b.png";